import { render, staticRenderFns } from "./SecurityForm.vue?vue&type=template&id=dc6c06c2&scoped=true&"
import script from "./SecurityForm.vue?vue&type=script&lang=js&"
export * from "./SecurityForm.vue?vue&type=script&lang=js&"
import style0 from "./SecurityForm.vue?vue&type=style&index=0&id=dc6c06c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc6c06c2",
  null
  
)

export default component.exports